import { decisioningStudioTiers } from "./constants";

/**
 * Read-only to the Go wizard and the agent's lifecycle actions: only GO agents are editable there.
 * Every other tier (PRO, the deprecated `ofl_legacy`, anything conman adds later) is managed by the
 * BrazeAI Decisioning Studio team and is read-only to them. The Pro action bank editor is gated
 * separately, by `useActionBankEditAccess`. A missing tier stays editable: the legacy sync-based
 * digest carries none, and a failed or 404 details query leaves it undefined.
 */
export const isReadOnlyUseCase = (tier?: string | null): boolean =>
  tier !== undefined && tier !== null && tier !== decisioningStudioTiers.GO;
